import PropTypes from "prop-types";
import React from "react";
import "./Avatar.css";
import Icon from "./Icon";

const Avatar = ({ src, size, alt, className }) => (
	<div
		className={`AvatarBox ${className}`}
		{...(size ? { style: { width: size, height: size } } : {})}>
		{src ? (
			<img src={src} alt={alt} />
		) : (
			<Icon shape="user" alt={alt} size={size} />
		)}
	</div>
);

Avatar.propTypes = {
	src: PropTypes.string,
	size: PropTypes.number,
	alt: PropTypes.string.isRequired
};

Avatar.defaultProps = {
	src: "",
	size: 30
};

export default Avatar;
